import sales from './sales/sales'

export default {
  mcc: {
    ...sales
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/mcc/mcc.js